import { render, staticRenderFns } from "./UserProjectsView.vue?vue&type=template&id=582b11af&scoped=true&"
import script from "./UserProjectsView.vue?vue&type=script&lang=js&"
export * from "./UserProjectsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "582b11af",
  null
  
)

export default component.exports